import React, { useMemo, useState, useEffect } from "react"

//import components
import {
  Col,
  Row,
  Card,
  CardBody,
  Container,
  Button,
  ButtonGroup,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  ButtonDropdown,
} from "reactstrap"
import {
  FaEdit,
  FaStreetView,
  FaTelegramPlane,
  FaRegPaperPlane,
} from "react-icons/fa"
import { useNavigate } from "react-router-dom"
import { useSelector, useDispatch } from "react-redux"

import Breadcrumbs from "../../../components/Common/Breadcrumb"
import TableContainer from "../../../components/Common/DataTableContainer"
import { fetchPvs } from "../../../redux/actions/pvs"
import { RESET_PVS_REGISTRATION } from "../../../redux/types/pvs"

const PvsPaidList = () => {
  document.title = "PVS Paid List | PULA"

  const history = useNavigate()
  const dispatch = useDispatch()

  const pvsState = useSelector(state => state.pvs)
  const fetchPvsState = useSelector(state => state.screens.pvs.fetchPvs)

  const [userData, setUserData] = useState([])
  const columns = useMemo(
    () => [
      {
        header: "Full Name",
        accessorKey: "seller_name",
        enableColumnFilter: true,
        enableSorting: true,
      },
      {
        header: "Email",
        accessorKey: "seller_email_id",
        enableColumnFilter: true,
        enableSorting: true,
      },
      {
        header: "Whatsapp Number",
        accessorKey: "whatsapp_number",
        enableColumnFilter: true,
        enableSorting: true,
      },
      {
        header: "Created At",
        accessorKey: "created_date",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Status",
        accessorKey: "status",
        enableColumnFilter: false,
        enableSorting: false,
        cell: () => <span className="badge bg-info">Pending Approval</span>,
      },
      {
        header: "Action",
        accessorKey: "action",
        enableColumnFilter: false,
        enableSorting: false,
        cell: info => {
          const row = info.row.original
          return (
            <div>
              <button
                className="btn btn-sm btn-info me-2"
                onClick={() => history(`/edit-pvs/${row.enc_pvs_entry_id}`)}
                title="Edit PVS"
              >
                {/* <FaEdit /> */}
                Edit
              </button>
              <button
                className="btn btn-sm btn-primary me-2"
                onClick={() =>
                  history(`/view-user/pvs/${row.enc_pvs_entry_id}`)
                }
                title="View PVS"
              >
                {/* <FaStreetView /> */}
                View User
              </button>
            </div>
          )
        },
      },
    ],
    []
  )

  useEffect(() => {
    dispatch({ type: RESET_PVS_REGISTRATION })
    let payload = { status: "paid" }
    dispatch(fetchPvs(payload))
  }, [])

  useEffect(() => {
    if (pvsState && Array.isArray(pvsState.paidPvsList)) {
      setUserData(pvsState.paidPvsList)
    }
  }, [pvsState])

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="mb-3 pb-2"></div>
        <div className="d-flex align-items-center justify-content-between mb-3">
          <div className="flex-grow-1">
            <h4 className="h4 mb-0 nom-title">Pending Approval</h4>
          </div>
          {/* <Button
            color="success"
            onClick={() => (window.location.href = "/pvs-form")}
          >
            Go to PVS Form
          </Button> */}
        </div>
        <TableContainer
          defaultPageSize={20}
          columns={columns}
          data={userData || []}
          isGlobalFilter={true}
          isPagination={true}
          isCustomPageSize={true}
          SearchPlaceholder="Search records..."
          pagination="pagination"
          paginationWrapper="dataTables_paginate paging_simple_numbers"
          tableClass=" table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
          theadClass="table-light"
          divClassName="table-responsive mb-4"
          noDataMessage={fetchPvsState.message}
        />
      </div>
    </div>
  )
}

export default PvsPaidList
